import { render, staticRenderFns } from "./ActionColMenu.vue?vue&type=template&id=6b7f3372"
import script from "./ActionColMenu.vue?vue&type=script&lang=js"
export * from "./ActionColMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports